import api from './api';

const vaccinationService = {
  // Get all vaccinations
  getAllVaccinations: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.animal_id) params.append('animal_id', filters.animal_id);
    
    const response = await api.get(`/api/vaccinations?${params.toString()}`);
    return response.data;
  },

  // Get overdue vaccinations (RED alerts)
  getOverdue: async () => {
    const response = await api.get('/api/vaccinations/overdue');
    return response.data;
  },

  // Get due soon vaccinations (YELLOW alerts)
  getDueSoon: async () => {
    const response = await api.get('/api/vaccinations/due-soon');
    return response.data;
  },

  // Get vaccination by ID
  getVaccinationById: async (id) => {
    const response = await api.get(`/api/vaccinations/${id}`);
    return response.data;
  },

  // Create vaccination
  createVaccination: async (vaccinationData) => {
    const response = await api.post('/api/vaccinations', vaccinationData);
    return response.data;
  },

  // Update vaccination
  updateVaccination: async (id, vaccinationData) => {
    const response = await api.put(`/api/vaccinations/${id}`, vaccinationData);
    return response.data;
  },

  // Delete vaccination
  deleteVaccination: async (id) => {
    const response = await api.delete(`/api/vaccinations/${id}`);
    return response.data;
  },

  // Mark as complete
  completeVaccination: async (id) => {
    const response = await api.post(`/api/vaccinations/${id}/complete`);
    return response.data;
  },

  // Get statistics
  getStats: async () => {
    const response = await api.get('/api/vaccinations/stats');
    return response.data;
  },
};

export default vaccinationService;